import ScreenerController from './controllers/ScreenerController';

let bingo: ScreenerController;

document.addEventListener('DOMContentLoaded', function () {
    createScreener();
});

function createScreener(): void {
    const bingo = new ScreenerController();
}